import { cyrb53 } from './utils/cyrb53';
import { isBrowser } from '../is-browser';
import { prodDomain } from './utils/constants';
// Fork of @pritulaziah ab-test hook without enormous md5 library.
// @see https://github.com/pritulaziah/ab-testing-hook
const PAGE_EXPERIMENTS_COOKIE_NAME = 'pageExperiments';
const getExperimentGroup = (uuid, { name, trafficPercentRange = 1, groups = [] }) => {
    const [minPercent, maxPercent] = Array.isArray(trafficPercentRange)
        ? trafficPercentRange
        : [0, trafficPercentRange];
    const currentId = cyrb53(`${name}${uuid}`) / Number.MAX_SAFE_INTEGER;
    if (currentId < minPercent || currentId >= maxPercent) {
        return null;
    }
    const preparedId = (currentId - minPercent) / (maxPercent - minPercent);
    let groupWeight = 0;
    const totalWeight = groups.reduce((accumulativeWeight, { weight }) => accumulativeWeight + weight, 0);
    const currentGroup = groups.find(group => {
        const currentWeight = group.weight / totalWeight;
        groupWeight += currentWeight;
        return preparedId < groupWeight;
    });
    return (currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.name) || null;
};
const getCookie = (cookieName) => {
    return document.cookie
        .split('; ')
        .map(cookie => cookie.split('='))
        .filter(([name]) => name === cookieName)
        .map(([_, value]) => value)[0];
};
const updatePageExperimentsCookie = (pageExperimentsCookie, experimentName, variant) => {
    if (experimentName && variant) {
        const pageExperiments = pageExperimentsCookie
            ? pageExperimentsCookie.split('+').map(experiment => experiment.split(':'))
            : [];
        const currentExperiment = pageExperiments.find(([testId]) => testId === experimentName);
        if (currentExperiment) {
            currentExperiment[1] = encodeURIComponent(variant);
        }
        else {
            pageExperiments.push([encodeURIComponent(experimentName), encodeURIComponent(variant)]);
        }
        return pageExperiments.map(experiment => experiment.join(':')).join('+');
    }
    return pageExperimentsCookie;
};
export const getConfigurableExperiment = (experimentName, userId, experiments = [], pageExperimentsCookie) => {
    const currentExperiment = experiments.find(experiment => experiment.name === experimentName);
    const variant = userId && currentExperiment ? getExperimentGroup(userId, currentExperiment) : null;
    const newPageExperimentsCookie = updatePageExperimentsCookie(pageExperimentsCookie, experimentName, variant);
    return { variant, isActive: !!currentExperiment, pageExperimentsCookie: newPageExperimentsCookie };
};
export const useConfigurableExperiment = (experimentName, userId, experiments = [], domain) => {
    var _a;
    const pageExperimentsCookie = isBrowser() ? getCookie(PAGE_EXPERIMENTS_COOKIE_NAME) : undefined;
    const result = getConfigurableExperiment(experimentName, userId, experiments, pageExperimentsCookie);
    if (isBrowser()) {
        window.pageExperiments = (_a = window.pageExperiments) !== null && _a !== void 0 ? _a : [];
        if (!window.pageExperiments.some(experimentString => experimentString.includes(experimentName))) {
            window.pageExperiments.push(`${experimentName}:${result.variant}`);
        }
        if (result.pageExperimentsCookie !== pageExperimentsCookie) {
            const expires = new Date();
            expires.setMonth(expires.getMonth() + 2);
            document.cookie = `${PAGE_EXPERIMENTS_COOKIE_NAME}=${result.pageExperimentsCookie}; Expires=${expires}; Domain=${domain || prodDomain}; Path=/`;
        }
    }
    return result;
};
